var hooxSliderReviews = document.querySelector(".hoox-reviews__items");
var hooxSliderReviewsLength = document.querySelectorAll(".hoox-reviews__items .swiper-slide").length;


if (hooxSliderReviews) {
    var slider = new Swiper(hooxSliderReviews, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            768: {
                slidesPerView: 10,
                loop: hooxSliderReviewsLength > this.slidesPerView,
                watchOverflow: true,
                loop: false,
                spaceBetween: 32,
            },
        },

        pagination: {
            el: '.hoox-reviews__dots',
            clickable: true,
        },
        navigation: {
            nextEl: ".hoox-swiper-reviews-arrow-next",
            prevEl: ".hoox-swiper-reviews-arrow-prev",
        },
    });
}
